module.exports = __webpack_public_path__ + "img/psyland-2020-cyber.f761213e.jpg";